<template>

  <section>

    <div style="height: 10px;">&nbsp;</div>

    <div class="img">
      <!-- <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">商务出行专属优惠：</div> -->
      <div>
        <img src="../assets/usecoupon.jpg" style="width: 100%;height: 180px;" />
      </div>
    </div>

    <button class="appointment" v-on:click="jumpDetail()" v-if="isGet == true" style="display: block;margin-bottom: 10px;padding: 5px;background:#fdd948;font-weight: bold;font-size: 20px !important;color: #c7131f;">一键领取红包</button>

    <div class="lineProd" v-if="coupon == true">
      <img src="../assets/10y.jpg" style="width: 100%;height:80px;" v-if="tenCoupon == true"
        v-on:click="userCoupon(tenID)" />
      <img src="../assets/10y_1.jpg" style="width: 100%;height:80px;" v-if="othertenCoupon == true"
        v-on:click="userCoupon(othertenID)" />
      <img src="../assets/30y.jpg" style="width: 100%;height:80px;" v-if="threetenCoupon == true"
        v-on:click="userCoupon(threetenID)" />
      <img src="../assets/50y.jpg" style="width: 100%;height:80px;" v-if="fivetenCoupon == true"
        v-on:click="userCoupon(fivetenID)" />
    </div>

    <!-- <div style="width: 96%;margin: 0 2% 10px;text-align: center;font-size: 20px;color:  #2754BB;">政企商务机票预约下单</div> -->

    <div class="demand">
      <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">预约信息填写：</div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的称呼：(必填)</div>
        <Input v-model="name" clearable placeholder="" />
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的联系电话：(必填)</div>
        <Input v-model="phone" type="tel" clearable placeholder="" />
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>出行人数：(必填)</div>
        <Input v-model="address" clearable placeholder="" />
      </div>
      <div>
        <div style="padding-left:10px;"><span style="color: red;">*</span>旅游目的地：(必填)</div>
        <Input v-model="demand" clearable type="textarea" :autosize="{minRows: 4,maxRows: 4}" />
      </div>
    </div>

    <button class="appointment" v-on:click="appointment()" style="display: block;margin-bottom: 10px;padding: 5px;background:#fdd948;font-weight: bold;font-size: 20px !important;color: #c7131f;">使用红包，提交预约</button>

    <div style="width: 96%;margin: 0 2%;text-align: center;">中山候机楼丨0760-88880777 / 18029902235</div>

  </section>
</template>

<script>
  import flightApi from '../request/flightApi';
  import baseTool from '../utils/baseFunction';
  import addressApi from '../request/addressApi';
  import userApi from '../request/userApi';
  import axios from 'axios';
  export default {
    name: 'aomenshopAppointment',
    data() {
      return {
        demand: '',
        name: '',
        phone: '',
        address: '',

        isGet:true,
        coupon: false,
        tenCoupon : false,
        tenID:'',
        othertenCoupon : false,
        othertenID:'',
        threetenCoupon : false,
        threetenID:'',
        fivetenCoupon : false,
        fivetenID:'',

        couponid:'',
      };
    },
    components: {},
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
      this.getUserAddress();

      userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
        console.log('getcardRes', getcardRes)
        if (getcardRes.success == true) {
          this.coupon = true;
          this.isGet = false;
          // this.coupon = false;
          // this.isGet = true;
          this.tenCoupon = false;
          this.othertenCoupon = false;
          this.threetenCoupon = false;
          this.fivetenCoupon = false;

          getcardRes.data.forEach(cardObj => {

            if (cardObj.CardID == 3 && cardObj.CardStatu == 0) {
              this.tenCoupon = true;
              this.tenID = cardObj.CardID;
            }
            if (cardObj.CardID == 4 && cardObj.CardStatu == 0) {
              this.threetenCoupon = true;
              this.threetenID = cardObj.CardID;
            }
            if (cardObj.CardID == 6 && cardObj.CardStatu == 0) {
              this.othertenCoupon = true;
              this.othertenID = cardObj.CardID;
            }
            if (cardObj.CardID == 5 && cardObj.CardStatu == 0) {
              this.fivetenCoupon = true;
              this.fivetenID = cardObj.CardID;
            }

          })
        }
      })

    },
    activated() {},
    methods: {
      getUserAddress() {
        userApi.getUserData(this.$store.state.user.OpenId).then(sucRes => {
          if (sucRes.success && sucRes.totalCount > 0) {
            this.name = sucRes.data.RealName;
            this.phone = sucRes.data.Mobile;
          }
        })
      },
      jumpDetail() {
        var that = this;
        // window.location.href = 'https://mp.weixin.qq.com/s/21njv-RsqYbc1L0rTLjrQQ';

        this.isGet = false;
        this.coupon = true
        this.tenCoupon = true;
        this.othertenCoupon = true;
        this.threetenCoupon = true;
        this.fivetenCoupon = true;

        userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
          console.log('getcardRes', getcardRes)
          that.cardList = getcardRes.data;
          if (getcardRes.success == false) {
            userApi.QueryCardList().then(cardRes => {
              console.log('cardRes', cardRes)
              if (cardRes.success == true && cardRes.totalCount > 0) {
                that.cardList = cardRes.data;
                cardRes.data.forEach(obj => {
                  userApi.PutCard(obj.ID, that.$store.state.user.OpenId).then(putRes => {
                    console.log('putRes', putRes)
                    if (putRes.success == true) {
                      this.$Modal.success({
                        title: '恭喜您!',
                        content: '领劵成功！'
                      });
                    }
                  })
                })
              }
            })
          } else {
            this.tenCoupon = false;
            this.othertenCoupon = false;
            this.threetenCoupon = false;
            this.fivetenCoupon = false;

            getcardRes.data.forEach(cardObj => {

              if (cardObj.CardID == 3 && cardObj.CardStatu == 0) {
                this.tenCoupon = true;
                this.tenID = cardObj.CardID;
                this.tenTitle = cardObj.Caedinfo.CardTitle;
              }
              if (cardObj.CardID == 4 && cardObj.CardStatu == 0) {
                this.threetenCoupon = true;
                this.threetenID = cardObj.CardID;
                this.threetenTitle = cardObj.Caedinfo.CardTitle;
              }
              if (cardObj.CardID == 6 && cardObj.CardStatu == 0) {
                this.othertenCoupon = true;
                this.othertenID = cardObj.CardID;
                this.othertenTitle = cardObj.Caedinfo.CardTitle;
              }
              if (cardObj.CardID == 5 && cardObj.CardStatu == 0) {
                this.fivetenCoupon = true;
                this.fivetenID = cardObj.CardID;
                this.fivetenTitle = cardObj.Caedinfo.CardTitle;
              }

            })

          }
        })

      },
      userCoupon(id){
        this.couponid = id;
      },
      appointment() {
        var that = this;

        if (this.name == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的称呼不能为空'
          });
          return;
        }
        if (this.phone == '' || this.phone.length < 8 || this.phone.length > 11 || this.phone.length == 9 || this.phone
          .length == 10) {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的联系电话不能为空或者电话号码长度不正确'
          });
          return;
        }
        if (this.address == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '出行人数不能为空'
          });
          return;
        }
        if (this.demand == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '旅游目的地不能为空'
          });
          return;
        }
        console.log(this.$store.state.user.OpenId, this.name, this.phone, this.demand, this.address);
        flightApi.appointmentFlight(
            this.$store.state.user.OpenId,
            '百万红包预约',
            this.name,
            this.phone,
            '百万红包预约:' + '旅游目的地:' + this.demand + '出行人数:' + this.address + '劵的ID' + this.couponid,
            null,
            null,
          )
          .then(sucRes => {
            this.demand = '';
            this.name = '';
            this.phone = '';
            this.address = '';
            if (sucRes.success == true) {
              this.$Modal.success({
                title: '恭喜你!',
                content: sucRes.message
              });
            } else {
              this.$Modal.error({
                title: '很遗憾!',
                content: sucRes.message
              });
            }
          });
      },
    },
  };
</script>

<style>
  .img {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
  }

  .demand {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
  }

  .infomation {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
  }

  .appointment {
    width: 94%;
    margin: 10px 3% 0 3%;
    background: #2754bb;
    color: white;
    height: 40px;
    font-size: 18px;
    border: 0;
    border-radius: 10px;
    line-height: 10px;
    /* margin-bottom: 10px; */
  }

  input::-webkit-input-placeholder {
    color: #515A6E;
  }

  input::-moz-input-placeholder {
    color: #515A6E;
  }

  input::-ms-input-placeholder {
    color: #515A6E;
  }

  .top_recognition {
    /* margin: 0 0 10px 0; */
  }

  .recognition {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/useCoupon.vue